import { render, staticRenderFns } from "./markupList.vue?vue&type=template&id=4a1228d3&scoped=true"
import script from "./markupList.vue?vue&type=script&lang=js"
export * from "./markupList.vue?vue&type=script&lang=js"
import style0 from "./markupList.vue?vue&type=style&index=0&id=4a1228d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1228d3",
  null
  
)

export default component.exports